import Model from '~/models/Model';

export default class ExperienceDomain extends Model {
  resource() {
    return 'v1/experience-domains';
  }
}
